import {Component, Input} from '@angular/core';

@Component({
  selector: 'field-integer-readonly',
  templateUrl: 'field-integer-readonly.component.html',
  styleUrls: ['field-integer-readonly.component.scss']
})
export class FieldIntegerReadonlyComponent {
  @Input() field: any;

  constructor() {
  }

  ngOnInit() {
  }

  get value() {
    return this.field.value?.data || [];
  }

}
